import React from 'react';
import { animateScroll as scroll } from 'react-scroll';

const CONTACT_EMAIL = 'renstia.finance@gmail.com';

function handleSubmit(event) {
  event.preventDefault();
  const form = event.currentTarget;
  const data = new FormData(form);
  const name = String(data.get('name') ?? '').trim();
  const email = String(data.get('email') ?? '').trim();
  const subject = String(data.get('subject') ?? '').trim();
  const message = String(data.get('message') ?? '').trim();

  const params = new URLSearchParams();
  if (subject) {
    params.set('subject', subject);
  }
  const bodyLines = [];
  if (name) {
    bodyLines.push(`Name: ${name}`);
  }
  if (email) {
    bodyLines.push(`Email: ${email}`);
  }
  if (bodyLines.length) {
    bodyLines.push('');
  }
  if (message) {
    bodyLines.push(message);
  }
  const body = bodyLines.join('\n');
  if (body) {
    params.set('body', body);
  }

  const query = params.toString();
  const mailto = query
    ? `mailto:${CONTACT_EMAIL}?${query}`
    : `mailto:${CONTACT_EMAIL}`;
  window.location.href = mailto;
}

function Contact() {
  return (
    <div className="containery contact">
      <h2 id="contact" className="main-title text-center">
        CONTACT
      </h2>
      <p className="contact-intro text-center">
        Write to us about a loan, a property question, or a build you have in mind. We reply to{' '}
        <a className="contact-email-inline" href={`mailto:${CONTACT_EMAIL}`}>
          {CONTACT_EMAIL}
        </a>{' '}
        and the number in the footer.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="col-md-12">
          <div className="rowy contact-fields-row">
            <div className="col-md-4 mb-1">
              <input name="name" placeholder="Name" className="contact-input" />
            </div>

            <div className="col-md-4 mb-1">
              <input name="email" type="email" placeholder="Email" className="contact-input" />
            </div>
            <div className="col-md-4 mb-1">
              <input name="subject" placeholder="Subject" className="contact-input" />
            </div>
          </div>
        </div>
        <br />
        <div className="col-md-12">
          <textarea name="message" placeholder="Message" className="contact-textarea" />
        </div>

        <br />
        <div className="rowy">
          <div className="col-md-12">
            <button className="form-btn" type="submit">
              Send message
            </button>
          </div>
        </div>
      </form>
      <button type="button" onClick={() => scroll.scrollToTop(2500)} className="gotop">
        <i className="fas fa-level-up-alt" />
      </button>
    </div>
  );
}

export default Contact;
